import React from 'react'
import { UncontrolledTooltip } from 'reactstrap';

export default function Email({children, label, id}) {

  return (

    <li>
      <span className='info-block-info-label'>{`${label}: `}</span>
      <span id={id}>{(children.length > 24) ? children.substr(0, 34) + '...' : children}</span>
    </li>
  )

  
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/InfoBlockComponents/Email.js